'use strict'

let loadimg

$(function(){

  // SPOT Index
  if( $("body").is("#spot.index") ){

    var slickWrap = $(".kokuhou-list");

    // 国宝の設定
    $.ajax({
      type: "GET",
      url: "/design/json/kokuhou.json",
      dataType: 'json',
      success: function(json){

        //load img
        loadimg = $('<div class="load-img"></div>');

        // jsonから要素をappend
        $(json).each(function(i){
          // var elm = $('<div class="item"><a href="/spot/detail/'+ this.id +'" data-num="'+ (i + 1) +'"></a></div>');
          // var thum = $('<div class="thum"><span></span></div>');
          // $('span', thum).css('background-image', 'url("/static-img/kokuhou/'+ this.img +'.png")');
          // var name = $('<p class="name">'+ this.name +'</p>');

          // $("a", elm).append(thum);
          // $("a", elm).append(name);

          // $(".slick-cont", slickWrap).append(elm);

          // var photo = $('<div class="photo" data-num="'+ (i + 1) +'"><span></span></div>');
          // $('span', photo).css('background-image', 'url("/static-img/kokuhou/'+ this.img +'.png")');
          // $(".view", slickWrap).append(photo);

          loadimg.append('<img class="load-img" alt="" src="/static-img/kokuhou/'+ this.img +'.png" />');
        });



        // 全画像読み込み後に実行
        loadimg.imagesLoaded( function(){
          $(".kokuhou-list").attr("data-current", 1);
          $(".kokuhou-list, .slick-cont").addClass("is-active");
        });

        $(".slick-cont", slickWrap).slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          vertical: true,
          autoplay: true,
          dots: false,
          responsive: [
            {
              breakpoint: 787,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              vertical: false,
              fade: true,
              infinite: true,
              dots: true,
              customPaging: function(slider, i) {
                return '<p>' + (i + 1) + '</p>';
              }
              }
            }
          ]
        });

        // mouse over設定
        $(".slick-cont .item", slickWrap).live('mouseover', function(){
          var num = $("a", this).attr("data-num");
          $(".kokuhou-list").attr("data-current", num);
        });
      }
    });

    // $(window).bind('enterBreakpoint787',function() {
    //     //
    // });

    // $(window).bind('exitBreakpoint787',function() {
    //     //
    // });

    // $(window).setBreakpoints({
    //     breakpoints: [787]
    // });
  }

});



// WEBPACK FOOTER //
// ./_src/js/cont/spot.js